import ConsultationWrapper  from '@mediline/mediline-api-middleware/src/wrappers/consultation.wrapper'

import HttpClient from './fetch_api';
import { CONSULTATION, CONSULTATION_BASE, INDICATIONS_TEMPLATE,CONSULTATION_OSDE } from '../conf/appSetting';

const cw = new ConsultationWrapper();

//export const ConsultationCreate = async (consultation, token) => cw.createConsultation(token, consultation);

export const ConsultationCreate = async (consultation, token) => cw.createAgoraConsultation(token, consultation);

export const ConsultationAgoraUpdate = async (consultation, token, id)  => cw.updateAgoraConsultation(token, consultation, id);

export const PostRanking = async (token, queueId, star) => cw.getRanking(token, queueId, star);

export const ConsultationGet = async (id, token) => cw.getConsultationById(token, id);

export const ConsultationUpdate = async (data, token) => cw.updateConsultation(token, data);

export const ConsultationPatientGet = async (token, params) => cw.getConsultationPatient(token, params);

export const getConsultationByAppointment = async (gatewayToken, params) =>
   HttpClient.get(HttpClient.concatNotNullParam(CONSULTATION.base, params), {
      Authorization: `Bearer ${gatewayToken}`,
   });
export const GetIndicationsPdf = async (consultationId, gatewayToken) => {
   const response = await fetch(`${CONSULTATION.base}/${consultationId}/indications/print`, {
      method: 'GET',
      headers: { Authorization: `Bearer ${gatewayToken}`, Accept: 'application/pdf' },
   });
   if (!response.ok) throw new Error('Error al descargar las indicaciones');
   return response.blob();
};

export const GetCertificatePdf = async (certificateId, gatewayToken) => {
   const response = await fetch(`${CONSULTATION_BASE}/certificate/${certificateId}/print`, {
      method: 'GET',
      headers: { Authorization: `Bearer ${gatewayToken}`, Accept: 'application/pdf' },
   });
   if (!response.ok) throw new Error('Error al descargar el certificado');
   return response.blob();
};

export const GetStudyPdf = async (studyId, gatewayToken) => {
   const response = await fetch(`${CONSULTATION_BASE}/studies/${studyId}/print`, {
      method: 'GET',
      headers: { Authorization: `Bearer ${gatewayToken}`, Accept: 'application/pdf' },
   });
   if (!response.ok) throw new Error('Error al descargar el estudio');
   return response.blob();
};

export const GetSpecialtyPdf = async (specialtyId, gatewayToken) => {
   const response = await fetch(`${CONSULTATION_BASE}/specialties/${specialtyId}/print`, {
      method: 'GET',
      headers: { Authorization: `Bearer ${gatewayToken}`, Accept: 'application/pdf' },
   });
   if (!response.ok) throw new Error('Error al descargar la derivación');
   return response.blob();
};

export const getIndicationsTemplate = async (gatewayToken) =>{
   
   let indications = await HttpClient.get(INDICATIONS_TEMPLATE.base, {
      Authorization: `Bearer ${gatewayToken}`,
   });

    return indications && indications.length && indications.map(indication => ({
        value: indication.id, label: indication.name, name: indication.name, id: indication.id
    }))}

export const validateOsdeAffiliateNumber = async (params, token) => {
    let osde = await HttpClient.get(
        HttpClient.concatNotNullParam(
            CONSULTATION_OSDE.base,
            params,
        ), {Authorization: `Bearer ${token}`}
    );

    return osde ;
};

export const getPatientFamilyGroupConsultations = async (gatewayToken, params) =>
   HttpClient.get(HttpClient.concatNotNullParam(`${CONSULTATION.base}/patientFamilyGroup`, params), {
      Authorization: `Bearer ${gatewayToken}`,
   });
